import styled from 'styled-components/macro';

export const StyledSortIndicator = styled.div<{ active: boolean }>`
  font-weight: bold;
  color: ${(props) =>
    props.active ? props.theme.grey.dark : props.theme.grey.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  span {
    margin-left: 3px;
  }
`;
